import React, { useEffect, useRef, useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import SimpleRenovate from "../../../assets/img/SimpleRenovate.svg";
import user from "../../../assets/img/profileIcon.png";
import logout from "../../../assets/img/logout mssg noti.svg";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  clearhitGetNotificationClientData,
  hitGetNotificationClientApi,
} from "../../../Redux/Client/GetNotificationsClientSlice";
import Logout from "../Setting/Sidebar/Logout/Logout";
import { useGlobalState } from "../../../Providers/GlobalStateProvider";

const NavbarProfessional = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const dropdownRefProfile = useRef(null);
  const [showProfile, setShowProfile] = useState(false);
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const {
    setNotificationData,
    setUnreadMessagesCount,
    setUnreadNotificationsCount,
  } = useGlobalState();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefProfile.current &&
        !dropdownRefProfile.current.contains(event.target)
      ) {
        setShowProfile(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(hitGetNotificationClientApi({ skip: 0, limit: 5 }));
  }, [dispatch]);

  const notificationsDataClient = useSelector(
    (state) => state.getNotificationClientReducer.data,
  );

  const notificationsDataClientAPIStatus = useSelector(
    (state) => state.getNotificationClientReducer.status,
  );

  useEffect(() => {
    if (
      notificationsDataClientAPIStatus !== null &&
      !notificationsDataClientAPIStatus
    ) {
      dispatch(clearhitGetNotificationClientData());
      localStorage.clear();
      navigate("/client/login");
      return;
    }
    if (notificationsDataClient && notificationsDataClient.status) {
      setNotificationData(notificationsDataClient.data);
      setUnreadMessagesCount(
        notificationsDataClient.count[0]?.unreadMessages || 0,
      );
      setUnreadNotificationsCount(
        notificationsDataClient.unreadNotificationsCount || 0,
      );
    }
  }, [
    notificationsDataClient,
    notificationsDataClientAPIStatus,
    dispatch,
    navigate,
    setNotificationData,
    setUnreadMessagesCount,
    setUnreadNotificationsCount,
  ]);

  const getProfileImage = () => {
    try {
      const clientData = JSON.parse(localStorage.getItem("clientData") || "null");
      const profileImage = clientData?.profileImage;
      if (profileImage && String(profileImage).trim() !== "") {
        return profileImage;
      }
      return user;
    } catch {
      return user;
    }
  };

  const handleOpenLogoutDialog = () => {
    setShowProfile(false);
    setShowLogoutDialog(true);
  };

  const isActive = (path) => location.pathname === path;

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
    <Navbar
      expand="lg"
      bg="white"
      className="nav-bar-width shadow py-0 py-lg-3 navbar_common navbar navbar-expand-lg navbar-light bg-white"
    >
      <div className="custom_container">
        <div className="nav-width nav_width_lg flex_dire_colm">
          <div className="img_toggle_btn">
            <Navbar.Brand href="/" onClick={() => handleViewDetails()}>
              <img
                src={SimpleRenovate}
                alt="Simple Renovate"
                className="navbar-logo "
              />
            </Navbar.Brand>
          </div>

          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-between"
          >
            <Nav className="gap-2 gap-lg-1 navbar_links md_display_none">
              <Nav.Link
                href="/client/dashboard"
                className={`nav-link-client ${
                  isActive("/client/dashboard") ? "active" : ""
                }`}
                onClick={() => handleViewDetails()}
              >
                Dashboard
              </Nav.Link>
            </Nav>

            <div className="d-flex align-items-center gap-3 mt-3 mt-lg-0 mb-3 mb-lg-0 position-relative">
              <div
                ref={dropdownRefProfile}
                className="profile-dropdown-wrapper"
                style={{ position: "relative", zIndex: 1050 }}
              >
                <div
                  className="profile-icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowProfile((prev) => !prev)}
                >
                  <img
                    src={getProfileImage()}
                    alt="user profile"
                    width={32}
                    height={32}
                    className="user-profile"
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = user;
                    }}
                  />
                </div>

                {showProfile && (
                  <div className="dropdown-menu show p-0 dropdown-menu-logout">
                    <div
                      className="dropdown-item"
                      style={{
                        padding: "10px 16px",
                        cursor: "pointer",
                        color: "#333",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                      onClick={handleOpenLogoutDialog}
                    >
                      <img src={logout} alt="logout" className="me-2" />
                      Logout
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Navbar.Collapse>
        </div>
      </div>
    </Navbar>

      {showLogoutDialog && (
        <Logout onCancel={() => setShowLogoutDialog(false)} />
      )}
    </>
  );
};

export default NavbarProfessional;
